import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

const DEFAULT_API_HOST = "app.pendo.io";
const pendoHost = (apiHost: string | undefined) => apiHost || DEFAULT_API_HOST;

export const pendo = defineConnector({
  identifier: "pendo",
  name: "Pendo",
  tagLine: "Product analytics and guidance",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ apiHost }) => domainToRegex(pendoHost(apiHost)),
  auth: (app) =>
    headerAuth([
      {
        name: "x-pendo-integration-key",
        value: app.secret.apiKey,
      },
    ]),
  steps: [
    {
      title: "Find your Pendo API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your [Pendo](https://app.pendo.io/) account, go to **Settings > Integrations > Integration Keys**. Click **Add Integration Key** and copy the generated key.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Pendo account settings.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "The API key for your Pendo account",
        },
        {
          kind: "select",
          label: "Region",
          required: true,
          defaultValue: DEFAULT_API_HOST,
          target: { kind: "configuration", field: "apiHost" },
          helperText:
            "Choose the region matching the URL you sign in to Pendo with.",
          options: [
            { value: DEFAULT_API_HOST, label: "US (app.pendo.io)" },
            { value: "us1.app.pendo.io", label: "US1 (us1.app.pendo.io)" },
            { value: "app.eu.pendo.io", label: "EU (app.eu.pendo.io)" },
            { value: "app.jpn.pendo.io", label: "Japan (app.jpn.pendo.io)" },
            { value: "app.au.pendo.io", label: "Australia (app.au.pendo.io)" },
          ],
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiHost }) => `https://${pendoHost(apiHost)}/api/v1/page`,
  },
});
